import { memo } from 'react'
import Icon from '~components/ui/icon'

interface SeeMoreOptionsButtonProps {
  onClick: () => void
}

const SeeMoreOptions = memo(({ onClick }: SeeMoreOptionsButtonProps) => {
  return (
    <button className="flex flex-row flex-gap-x-2 py-4 px-5" onClick={onClick}>
      <Icon name="plus" />
      <span className="text-title-3 text-primary-500">See more options</span>
    </button>
  )
})

SeeMoreOptions.displayName = 'SeeMoreOptions'

export default SeeMoreOptions
